import { useTruck } from "./hook";
import { truckMutations } from "./mutations";
import { truckQueries } from "./queries";

export const truckService = {
  query: truckQueries,
  mutation: truckMutations,
  useTruck
};
